import { Reveal, RevealLines } from "../motion/Reveal";

const CHAPTERS = [
  {
    n: "01",
    title: "Coverage without seams.",
    body: "One dispatch, one accountable operations team, one contract that spans the province — from Vancouver Island marinas to Peace Region camp gates. No handoffs. No blind spots.",
  },
  {
    n: "02",
    title: "Officers, not seat-fillers.",
    body: "Every officer holds a valid BC Security Worker License and completes site-specific orientation before their first shift. We measure retention in years, not weeks.",
  },
  {
    n: "03",
    title: "Reporting you can actually read.",
    body: "Digital patrol logs, GPS-verified check-ins, photographic incident evidence — delivered by morning, indexed by site, searchable by date and officer.",
  },
  {
    n: "04",
    title: "Built for BC's edges.",
    body: "Fly-in fly-out rotations, remote camp protocols, MTSR-compliant marine ops, AHJ-coordinated fire watch — the operational muscle to work where the highway ends.",
  },
];

export default function Manifesto() {
  return (
    <section
      className="bg-[#F4F4F0] py-24 md:py-40 border-y border-black/10"
      data-testid="home-manifesto"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
      <div className="md:sticky md:top-32">
        <div className="font-mono text-[10px] tracking-[0.28em] uppercase text-[#D92323]">
          Manifesto
        </div>
        <RevealLines
          as="h2"
          lines={["Four principles.", "One province.", "Zero excuses."]}
          className="mt-6 font-display text-4xl md:text-5xl leading-[0.95] tracking-tight text-[#060913]"
        />
        <p className="mt-8 text-[#5C5F66] max-w-sm">
          We opened in Vancouver in 2011 and built our operations to serve
          British Columbia — and only British Columbia — with the rigor
          usually reserved for national accounts.
        </p>
      </div>
        </div>

        <div className="md:col-span-8">
          <div className="space-y-24">
            {CHAPTERS.map((c, i) => (
              <Reveal key={c.n} delay={i * 0.05}>
                <article className="grid grid-cols-12 gap-6 items-start border-t border-black/10 pt-10">
                  <div className="col-span-3 md:col-span-2">
                    <div className="font-mono text-5xl md:text-7xl text-[#D92323] leading-none">
                      {c.n}
                    </div>
                  </div>
                  <div className="col-span-9 md:col-span-10">
                    <h3 className="font-display text-3xl md:text-4xl leading-tight tracking-tight text-[#060913]">
                      {c.title}
                    </h3>
                    <p className="mt-4 text-[#5C5F66] text-base md:text-lg leading-relaxed max-w-2xl">
                      {c.body}
                    </p>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
